import { format } from 'date-fns';

export const dateTimeFormat = (date?: Date | string | number): string => {
	if (!date) {
		return '';
	}

	return format(new Date(date), 'dd/MM/yyyy HH:mm:ss');
};

export const dateFormat = (date?: Date | string | number): string => {
	if (!date) {
		return '';
	}

	const parsed = new Date(date);
	return format(parsed, 'yyyy-MM-dd');
};

export const timeFormat = (date?: Date | string | number): string => {
	if (!date) {
		return '';
	}

	const parsed = new Date(date);
	return format(parsed, 'HH:mm:ss');
};

export const atStartOfDay = (date?: Date | string | number): string => {
	if (!date) {
		date = new Date();
	}

	const parsed = new Date(date);
	return format(parsed, 'yyyy-MM-dd');
};

export const minusDays = (
	days: number,
	date?: Date | string | number
): Date => {
	return minusSeconds(days * 24 * 60 * 60, date);
};

export const minusSeconds = (
	seconds: number,
	date?: Date | string | number
): Date => {
	if (!date) {
		date = new Date();
	}

	const parsed = new Date(date);
	parsed.setSeconds(parsed.getSeconds() - seconds);
	return parsed;
};
